import { reactive, inject } from "vue";

import Pesquisa from "@/services/pesquisaSatisfacao/Pesquisa";
const { getPesquisasPendentes } = Pesquisa();

const store = reactive({
  pesquisasPendentes: []
});

export const storePesquisaSymbol = Symbol("PesquisaAvisoStore");
export const createAvisoPesquisaState = () => store;
export const useAvisoPesquisaState = () => inject(storePesquisaSymbol);

export const buscaAvisos = itsmTool => {
  switch (itsmTool) {
    case 1: // CASDM (1) não utiliza essa entidade
      return;
    default:
      getPesquisasPendentes().then(res => {
        store.pesquisasPendentes = res.data;
      });
      break;
  }
};
